module.exports = __webpack_public_path__ + "static/media/pdf.91ee0068.svg";